import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ROUTE from '../../constants/route';
import {Role} from '../../helpers/user';

import SvgButton from '../SvgButton';

import Links from './schema';
import './styles.css';

const Footer = props => {
  const { user } = props;

  const footerNavs = useMemo(() => {
    const isCandidate = Role.isCandidate(user);

    const handleLinkClick = () => {
      Role.isCandidate(user, true);
      document.activeElement.blur();
    };

    return Links.map((nav, i) => (
      <div className="footer__nav" key={i}>
        <h3 className="footer__nav-title">{nav.title}</h3>
        <ul className="footer__nav-list">
          {nav.items
            .filter(link =>
              user.isLoggedIn ? !link.anonymousOnly : !link.candidateOnly
            )
            .map((link, j) => (
              <li className="footer__nav-item" key={j}>
                {link.href ? (
                  <a className="footer__nav-link" href={link.href}>
                    {link.text}
                  </a>
                ) : link.to === ROUTE.CANDIDATE_UPGRADE_PREMIUM ? (
                  Role.isCandidate(user) &&
                  !Role.isRecruiter(user) &&
                  (!Role.isCandidatePremium(user) ||
                    !Role.isCandidatePremiumWithPrep(user)) ? (
                    <Link className="footer__nav-link" to={link.to}>
                      {link.text}
                    </Link>
                  ) : null
                ) : (
                  <Link
                    className="footer__nav-link"
                    to={isCandidate ? link.to : '#'}
                    onClick={handleLinkClick}
                  >
                    {link.text}
                  </Link>
                )}
              </li>
            ))}
        </ul>
      </div>
    ));
  }, [user]);

  return (
    <footer
      className="footer"
      // style={{ backgroundImage: 'url(' + pattern + ')' }}
    >
      <div className="container">
        <div className="footer__top">
          <div className="footer__company-info">
            <a className="footer__logo" href="/">
              <span className={'footer__logo-img'}>
                <svg
                  width="177"
                  height="36"
                  fill="none"
                  viewBox={'0 0 177 36'}
                  role={'img'}
                  aria-label={'GoBuyside'}
                >
                  <path
                    d="M12.34 8.36a6.8 6.8 0 0 1 2.52 2.17v-2.7h4.8v19.01c0 1.75-.35 3.31-1.05 4.68a7.84 7.84 0 0 1-3.17 3.27c-1.41.8-3.12 1.21-5.12 1.21-2.68 0-4.88-.62-6.59-1.87a6.94 6.94 0 0 1-2.91-5.11h4.73c.25.86.8 1.55 1.62 2.06.83.51 1.83.77 3.01.77 1.39 0 2.51-.42 3.38-1.25.86-.83 1.3-2.08 1.3-3.76V23.9A7.57 7.57 0 0 1 8.61 27c-1.6 0-3.05-.41-4.37-1.23a8.53 8.53 0 0 1-3.12-3.46A11.2 11.2 0 0 1 0 17.2c0-1.93.38-3.6 1.14-5.07a8.24 8.24 0 0 1 7.48-4.6c1.41 0 2.65.28 3.72.84Zm1.84 5.93a4.83 4.83 0 0 0-4.33-2.58 4.83 4.83 0 0 0-4.28 2.54c-.46.83-.7 1.81-.7 2.95 0 1.13.23 2.12.7 2.98.47.85 1.08 1.5 1.84 1.95.76.46 1.58.68 2.44.68a4.96 4.96 0 0 0 4.33-2.57c.45-.83.68-1.82.68-2.98s-.23-2.15-.68-2.98ZM27.37 25.8a8.73 8.73 0 0 1-3.42-3.43 10.25 10.25 0 0 1-1.25-5.1c0-1.94.43-3.64 1.28-5.12a8.9 8.9 0 0 1 3.5-3.42c1.47-.8 3.12-1.2 4.93-1.2 1.82 0 3.47.4 4.94 1.2a8.9 8.9 0 0 1 3.5 3.42 10.03 10.03 0 0 1 1.28 5.11c0 1.93-.44 3.64-1.32 5.11a9.13 9.13 0 0 1-3.54 3.43c-1.49.8-3.15 1.2-5 1.2a9.9 9.9 0 0 1-4.9-1.2Zm7.35-3.58a4.56 4.56 0 0 0 1.82-1.88c.45-.84.68-1.86.68-3.07 0-1.8-.47-3.17-1.41-4.14a4.66 4.66 0 0 0-3.46-1.44c-1.36 0-2.51.48-3.43 1.44-.92.97-1.38 2.35-1.38 4.14 0 1.8.45 3.17 1.34 4.14.9.96 2.03 1.45 3.4 1.45.86 0 1.67-.21 2.43-.63Z"
                    fill={'#6A91F0'}
                  />
                  <path
                    d="M52.4 8.38a7.8 7.8 0 0 1 3.7-.85 8.25 8.25 0 0 1 7.49 4.58 10.9 10.9 0 0 1 1.14 5.09c0 1.93-.38 3.64-1.14 5.13a8.55 8.55 0 0 1-3.1 3.45 8.1 8.1 0 0 1-4.38 1.23c-1.41 0-2.65-.28-3.7-.84a7.15 7.15 0 0 1-2.54-2.16v2.69H45.1V1.5h4.77v9.1a6.83 6.83 0 0 1 2.54-2.22Zm6.75 5.88a4.8 4.8 0 0 0-4.3-2.54 4.7 4.7 0 0 0-2.45.66 4.96 4.96 0 0 0-1.84 1.93c-.46.84-.7 1.83-.7 2.96 0 1.14.24 2.13.7 2.97a4.9 4.9 0 0 0 4.28 2.59 4.8 4.8 0 0 0 4.31-2.63c.47-.84.7-1.84.7-3 0-1.15-.23-2.1-.7-2.94ZM85.52 7.83V26.7h-4.8v-2.38a6.28 6.28 0 0 1-2.4 1.92c-1 .47-2.07.7-3.23.7a8 8 0 0 1-3.92-.93 6.57 6.57 0 0 1-2.67-2.76 9.1 9.1 0 0 1-.97-4.35V7.83h4.77v10.39c0 1.5.38 2.65 1.12 3.46.75.8 1.78 1.2 3.07 1.2 1.3 0 2.35-.4 3.1-1.2.75-.8 1.13-1.96 1.13-3.46V7.83h4.8ZM108.33 7.83l-11.69 27.8h-5.07l4.09-9.4-7.57-18.4h5.35l4.87 13.18 4.94-13.18h5.08ZM113.13 26.17a7.37 7.37 0 0 1-2.91-2.26c-.72-.95-1.11-2-1.18-3.17h4.8c.1.73.45 1.33 1.08 1.8.62.48 1.4.72 2.33.72.93 0 1.62-.18 2.13-.54.51-.37.77-.83.77-1.4 0-.61-.31-1.07-.94-1.38-.62-.3-1.61-.64-2.98-1-1.4-.34-2.56-.7-3.46-1.06a6.03 6.03 0 0 1-2.32-1.67 4.47 4.47 0 0 1-.97-3.03c0-1.05.3-2 .9-2.86a6.04 6.04 0 0 1 2.6-2.05 9.7 9.7 0 0 1 3.97-.74c2.25 0 4.04.56 5.38 1.68a6.24 6.24 0 0 1 2.22 4.55h-4.57a2.48 2.48 0 0 0-.94-1.8 3.48 3.48 0 0 0-2.23-.66c-.87 0-1.53.16-2 .48-.46.32-.7.76-.7 1.33 0 .63.32 1.12.96 1.45.63.32 1.62.66 2.96 1 1.36.34 2.49.7 3.38 1.06a6 6 0 0 1 2.3 1.68c.65.76.98 1.76 1 3.01 0 1.1-.3 2.07-.9 2.93a5.9 5.9 0 0 1-2.6 2.03 9.82 9.82 0 0 1-3.93.73c-1.5 0-2.93-.28-4.16-.84l.01.01ZM128.15 4.79a2.65 2.65 0 0 1-.83-2c0-.8.27-1.46.83-1.99.56-.53 1.25-.8 2.1-.8.84 0 1.54.27 2.1.8.55.53.83 1.2.83 2 0 .79-.28 1.45-.83 1.99-.56.53-1.26.8-2.1.8-.84 0-1.54-.27-2.1-.8Zm4.45 3.04V26.7h-4.77V7.83h4.77ZM136.91 12.13a8.3 8.3 0 0 1 11.03-3.8c1.1.53 2 1.24 2.66 2.13V1.5h4.83v25.2h-4.84v-2.8a6.5 6.5 0 0 1-2.48 2.26c-1.07.57-2.3.85-3.72.85-1.59 0-3.04-.4-4.36-1.22a8.53 8.53 0 0 1-3.12-3.46 11.12 11.12 0 0 1-1.14-5.13c0-1.92.38-3.6 1.14-5.07Zm13.04 2.16a4.83 4.83 0 0 0-4.33-2.58 4.83 4.83 0 0 0-4.28 2.54c-.46.83-.7 1.81-.7 2.95 0 1.13.24 2.12.7 2.98.47.85 1.08 1.5 1.84 1.95.76.46 1.58.68 2.44.68a4.96 4.96 0 0 0 4.33-2.57c.45-.83.68-1.82.68-2.98s-.23-2.15-.68-2.98ZM176.86 18.7h-13.8c.1 1.36.59 2.42 1.43 3.2a4.41 4.41 0 0 0 3.1 1.15 3.9 3.9 0 0 0 3.78-2.28h5.15a8.58 8.58 0 0 1-3.14 4.48 9.17 9.17 0 0 1-5.7 1.75c-1.8 0-3.44-.4-4.88-1.2a8.52 8.52 0 0 1-3.38-3.43 10.5 10.5 0 0 1-1.2-5.11c0-1.93.39-3.67 1.19-5.14a8.31 8.31 0 0 1 3.33-3.4 10 10 0 0 1 4.94-1.2c1.87 0 3.4.39 4.83 1.16a8.16 8.16 0 0 1 3.3 3.28 9.93 9.93 0 0 1 1.18 4.9c0 .67-.04 1.28-.13 1.83Zm-4.81-3.2a3.78 3.78 0 0 0-1.33-2.95 4.73 4.73 0 0 0-3.17-1.1c-1.18 0-2.18.35-2.98 1.06a4.7 4.7 0 0 0-1.48 2.99h8.96Z"
                    fill={'hsl(var(--gbs-default-200))'}
                  />
                </svg>
              </span>
            </a>

            <SvgButton
              btnWidth={200}
              btnFontWeight={600}
              btnHeight={40}
              btnHref="/contact"
              btnText="Contact Us"
              btnArrow={true}
            />
          </div>
          <div className="footer__navs">{footerNavs}</div>
        </div>

        <div className="footer__bottom">
          <div className="footer__legal-links">
            <a href="/privacy" className="footer__legal-link">
              Privacy Policy
            </a>
            <a href="/terms" className="footer__legal-link">
              Terms of Use
            </a>

            <div className="footer__icon-links">
              <a
                className="footer__icon-link footer__icon-link--linkedin icon-soc-linkedin"
                target={'_blank'}
                href="https://www.linkedin.com/company/gobuyside"
              >{``}</a>
              <a
                className="footer__icon-link footer__icon-link--envelope icon-soc-email"
                target={'_blank'}
                href="mailto:firms@gobuyside.com?subject=GoBuyside Inquiry"
              >{``}</a>
            </div>
          </div>

          <div className="footer__copyright">
            GoBuyside LLC. © {new Date().getFullYear()} – All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
